/* lua.js generated code 0.3.0 */
 //colorList = {{{180}, {1}, {0}, {4}},{{0}, {1.5}, {-0.1}, {2}},{{-50}, {1.5}, {-0.1}, {2}}}
colorList = table(
    [0, table(180)],
    [0, table(140)],
    [0, table(90)],
    [0, table(30)],
    [0, table([0, -30])],
    [0, table([0, -60])],
    [0, table(0)]
)
GamePlayConfig_Board_Scale = 0.95
GamePlayConfig_Tile_Width = 70
GamePlayConfig_Tile_Height = 70
GamePlayConfig_Tile_PosAddX = 5
GamePlayConfig_Design_Width = 720
GamePlayConfig_Design_Height = 1280
GamePlayConfig_RESOLUTION_SCALE = display.height / GamePlayConfig_Design_Height
GamePlayConfig_UI_ADAPT_MIN_SCALE = Math.min(GamePlayConfig_RESOLUTION_SCALE, display.width / GamePlayConfig_Design_Width)
UI_RESOLUTION_SCALE = Math.min(GamePlayConfig_Design_Width / display.width, GamePlayConfig_Design_Height / display.height)
GamePlayConfig_Max_Width = 960
GamePlayConfig_Top_Height = 395
GamePlayConfig_Bottom_Height = 172
GamePlayConfig_Strengh_Scale = 1
GamePlayConfig_Tile_ScaleX = 1
GamePlayConfig_Tile_ScaleY = 1
GamePlayConfig_Tile_BorderWidth = 4
GamePlayConfig_Tile_Ingr_CollectorY = 4
GamePlayConfig_Tile_Ingr_Height = 27
GamePlayConfig_Max_Item_Y = 10
GamePlayConfig_Max_R = 9
GamePlayConfig_Max_C = 9
GamePlayConfig_Static_Animal_Scale = 1.06
GamePlayConfig_Music_Effect_Open = true
GamePlayConfig_Background_Music_Open = true
GamePlayConfig_Action_FPS = 60
GamePlayConfig_Action_FPS_Time_Scale = GamePlayConfig_Action_FPS / 60
GamePlayConfig_Action_FPS_Time_Scale_F = 60 / GamePlayConfig_Action_FPS
GamePlayConifg_Replay_Saved_Max = 100
GamePlayConfig_CharacterAnimationTime = 1 / 30
GamePlayConfig_FallingSpeed_Delay = 30 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_FallingSpeed_Start = 2 * GamePlayConfig_Action_FPS_Time_Scale_F
GamePlayConfig_FallingSpeed_Add = 1.6 * GamePlayConfig_Action_FPS_Time_Scale_F
GamePlayConfig_FallingSpeed_Max = 34 * GamePlayConfig_Action_FPS_Time_Scale_F
GamePlayConfig_FallingSpeed_Pass_Start = 8 * GamePlayConfig_Action_FPS_Time_Scale_F
GamePlayConfig_Viberate_InitY = 0.01
GamePlayConfig_Viberate_Count = 4
GamePlayConfig_Viberate_Delay = 2
GamePlayConfig_SwapAction_CD = 10 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SwapAction_Failed_CD = 8 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SwapAction_Fun_CD = 6 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SwapAction_Fun_Failed_CD = 6 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_GameItemAnimalDeleteAction_CD = 12 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_GameItemAnimalDeleteAction_CD_View = 12 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_GameItemLockDeleteAction_CD = 18 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_GameItemCrystalDeleteAction_CD = 18 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_GameItemGiftDeleteAction_CD = 18 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_GameItemBlockerDeleteAction_CD = 16 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_GameItemGreyFurballDeleteAction_CD = 35 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_GameItemDigGroundDeleteAction_CD = 18 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_GameItemDigJewelDeleteAction_CD = 18 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_GameItemGiftBoxOpenAction_CD = 46 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_GameItemFishDeleteAction_CD = 40 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_GameItemAlienBDeleteAction_CD = 1 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_GameItemBoatDeleteAction_CD = 40 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_GameItemIceBombDeleteAction_CD = 30 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_Line_Anim_CD = 30 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_Line_Add_CD = 1 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_Column_Anim_CD = 30 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_Wrap = 30 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_WrapWrap = 34 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_WrapLine = 30 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_LineFourTile = 20 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_DoubleFourTile = 20 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_FourTile = 30 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_WrapFourTile = 30 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_BirdAnimal_Time1 = 100 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_BirdAnimal_Time2 = 22 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_BirdAnimal_Time3 = 75 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_BirdAnimal_Shake_Time = 45 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_BirdLine_Time1 = 3000 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_BirdLine_Time2 = 15 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_BirdLine_Time3 = 6 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_BirdLine_Time4 = 20 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_BirdLine_Time5 = 5 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_BirdLine_Time6 = 50 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_SuperBirdLine_Time1 = 3000 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_SuperBirdLine_Time2 = 15 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_SuperBirdLine_Time3 = 3 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_SuperBirdLine_Time4 = 20 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_SuperBirdLine_Time5 = 5 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_SuperBirdLine_Time6 = 50 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_BirdBird_Time1 = 10000 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_BirdBird_Time2 = 30 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_BirdBird_Time3 = 20 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_BirdBird_Time4 = 30 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_BirdBird_Time5 = 25 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_SpecialBomb_FourTile_WAIT_SECOND = 30
GamePlayConfig_Falling_MaxTime = 3000 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Falling_LeftRight_Time = 8 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Falling_LeftRight_Speed_X = GamePlayConfig_Tile_Width / GamePlayConfig_Falling_LeftRight_Time
GamePlayConfig_Falling_LeftRight_Speed_Y = GamePlayConfig_Tile_Height / GamePlayConfig_Falling_LeftRight_Time
GamePlayConfig_IceDeleted_Pos_Add_X = -20
GamePlayConfig_IceDeleted_Pos_Add_Y = -20
GamePlayConfig_LockDeleted_Pos_Add_X = 2
GamePlayConfig_LockDeleted_Pos_Add_Y = -33
GamePlayConfig_Honey_Disappear = 24 * GamePlayConfig_Action_FPS / 30
GamePlayConfig_Jam_Disappear = 24 * GamePlayConfig_Action_FPS / 30
GamePlayConfig_Ice_Dec = 25 * GamePlayConfig_Action_FPS / 30
GamePlayConfig_Dandelion_Dec = 30 * GamePlayConfig_Action_FPS / 30
GamePlayConfig_Add_Move_Base = 5
GamePlayConfig_Light_Up_Block = 48 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_VarSnow_MathAt = 5 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Furball_Dec = 17 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_VariousBox_Upgrade = 27 * GamePlayConfig_Action_FPS / 30
GamePlayConfig_BlockCollectCatch = 69 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_GameItemSnowDeleteAction_CD = GamePlayConfig_GameItemBlockerDeleteAction_CD
GamePlayConfig_GameItemVarSnowBomb_CD = 26
GamePlayConfig_SnowDeleted_Pos_Add_X = table(
    2,
    2,
    2,
    2,
    2
)
GamePlayConfig_SnowDeleted_Pos_Add_Y = table(
    [0, -33],
    [0, -33],
    [0, -33],
    [0, -33],
    [0, -33]
)
GamePlayConfig_SnowDeleted_Action_Count = table(
    12,
    27,
    18,
    22,
    22
)
GamePlayConfig_GameItemReefDeleteAction_CD = 1000
GamePlayConfig_GameItemReefBomb_CD = 32 * 2
GamePlayConfig_GameItemSoilBomb_CD = 21
GamePlayConfig_GameItemWaterFlow_CD = 5
GamePlayConfig_GameItemReefClock = 18
GamePlayConfig_SurfingCatMaxLevel = 3
GamePlayConfig_GameItemCoinDeleteAction_CD = GamePlayConfig_GameItemAnimalDeleteAction_CD
GamePlayConfig_GameItemMissileDeleteAction_CD = 13 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Hammer_Pos = ccp(64, -2)
GamePlayConfig_Hammer_Animation_CD = 10 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Hammer_Bit_Animation_CD = 32 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Hammer_InitAngle = 0
GamePlayConfig_Hammer_UpAngle = 30
GamePlayConfig_Hammer_HitAngle = -45
GamePlayConfig_Hammer_FinalAngle = -20
GamePlayConfig_Hammer_1stUpTime = 12 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Hammer_DownTime = 6 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Hammer_2ndUpTime = 6 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Impact_Pos = ccp(20, 10)
GamePlayConfig_Impact_InitScale = 0.2
GamePlayConfig_Impact_2ndScale = 1
GamePlayConfig_Impact_FinalScale = 1.5
GamePlayConfig_Impact_InitOpacity = 0.4
GamePlayConfig_Impact_2ndOpacity = 255
GamePlayConfig_Impact_FinalOpacity = 0
GamePlayConfig_Impact2ndTime = 6 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_ImpackFinalTime = 6 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Hammer_Viberate_Time = 18 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_LineBrush_AnchorPoint = ccp(0.3, 0.6)
GamePlayConfig_LineBrush_Animation_CD = 10 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_LineBrush_Comet_ShowDelay = 0.05
GamePlayConfig_LineBrush_Comet_ScaleWait = 0.15
GamePlayConfig_LineBrush_Comet_ScaleDuration = 0.05
GamePlayConfig_LineBrush_Comet_FinalScaleY = 1.3
GamePlayConfig_LineBrush_Comet_MovingTime = 18 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_LineBrush_Star1_Scale = 1
GamePlayConfig_LineBrush_Star2_Scale = 2
GamePlayConfig_LineBrush_Star3_Scale = 1.5
GamePlayConfig_LineBrush_Star1_InitX = 6
GamePlayConfig_LineBrush_Star2_InitX = -5
GamePlayConfig_LineBrush_Star3_InitX = 1
GamePlayConfig_LineBrush_Star1_FinalX = 10
GamePlayConfig_LineBrush_Star2_FinalX = -6
GamePlayConfig_LineBrush_Star3_FinalX = 4
GamePlayConfig_LineBrush_Star1_InitY = 30
GamePlayConfig_LineBrush_Star2_InitY = 14
GamePlayConfig_LineBrush_Star3_InitY = 45
GamePlayConfig_LineBrush_Star1_FinalY = 50
GamePlayConfig_LineBrush_Star2_FinalY = 18
GamePlayConfig_LineBrush_Star3_FinalY = 72
GamePlayConfig_LineBrush_Star1_MovingTime = 24 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_LineBrush_Star2_MovingTime = 21 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_LineBrush_Star3_MovingTime = 30 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Back_AnimTime = 0.2
GamePlayConfig_Product_As_Clipping = true
GamePlayConfig_Prop_Line_AnimTime = 15
GamePlayConfig_Score_MatchDeleted_UP_Time = 20 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Score_MatchDeleted_Stop_Time = 25 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Score_MatchDeleted_Fly_Time = 20 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Score_MatchDeleted_Scale = 0.6
GamePlayConfig_GamePlayType_Can_SwapSwapSwap = false
GamePlayConfig_CIRCUS_A_COLLECT_Time = 80 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_CIRCUS_A_2_B_Time = 60 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_CIRCUS_B_LIGHT_UP_Time = 20 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_CIRCUS_B_ACTIVE_Time = (70 + 58) * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_CIRCUS_B_REMOVE_Time = (160 - 70 - 58) * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Refresh_BaseSwap_Count = 30
GamePlayConfig_Refresh_Item_Flying_Time = 55 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Missile_Fly_Time = 40 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_FireWork_Fly_Time = 36 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_BonusTime_Total = 100000 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_BonusTime_RandomBomb_CD = 8 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_BonusTime_ItemFlying_CD = 16 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_BonusTime_ItemFlySpeed = 3200
GamePlayConfig_BonusTime_ItemFlying = 60 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_BonusTime_ItemBomb_CD = 20 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_BonusTime_Effect_DelayTime = 1.8
GamePlayConfig_BonusTime_Effect_TimeScale = 0.65
GamePlayConfig_MaxAction_time = 100000 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_CrystalChange_time = 16 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Furball_Transfer = 10000 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Furball_Split = 10000 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Roost_Replace = 1000 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Roost_Upgrade_Level1 = 55
GamePlayConfig_Roost_Upgrade_Level2 = 25
GamePlayConfig_Roost_Upgrade_Level3 = 35
GamePlayConfig_PM25_ChangeItem_Max_Count = 3
GamePlayConfig_Mimosa_Grow_Step = 2
GamePlayConfig_Mimosa_Grow_Grid_Num = 2
GamePlayConfig_Mimosa_Back_Num = 1
// GamePlayConfig_SeaAnimal_Penguin_Score = 10000
// GamePlayConfig_SeaAnimal_Seal_Score = 10000
// GamePlayConfig_SeaAnimal_Bear_Score = 10000
GamePlayConfig_Transmission_Time = 30 / 30
GAMEITEM_CIRCLE_MAX_STRENGTH = 6
GamePlayConfig_FISH_MAX_STRENGTH = 3
GamePlayConfig_BOSS_DAMAGE_COLORFUL = 0
GamePlayConfig_BOSS_DAMAGE_BLOCK = 0
GamePlayConfig_BOSS_DAMAGE_COIN = 0
GamePlayConfig_BOSS_DAMAGE_VAR_SNOW = 0
GamePlayConfig_BOSS_DAMAGE_CAGE = 0
GamePlayConfig_Color_Strong_Effect = 2
GamePlayConfig_BOSS_DAMAGE_Lighthouse = 1
GamePlayConfig_BOSS_DAMAGE_TIP_SHOW_TIMES_PER_DAY = 999
GamePlayConfig_Damage_Limit_Strength = 200
GamePlayConfig_ONE_BOSS_MAX_BLOOD = 14
GamePlayConfig_Boss_Damage_Effect_Max_Count = 10
GamePlayConfig_Boss_Charge_Effect_Max_Count = 10
GamePlayConfig_Ball_Strength = 3
GamePlayConfig_Ball_Damage_To_Boss = 4
GamePlayConfig_RiceBag_Damage_To_Boss = 2
GamePlayConfig_Ratel_Damage_To_Boss = 6
PetSkillType = table.const(table([1, "kChangeToSpecial", "changeToSpecial"], [1, "kBomb", "bomb"]))
GamePetConfig = table.const(table(
    [1, GameColor.kPurple, table(
        [1, "fullEnergy", 10],
        [1, "damage", 1],
        [1, "skills", table()]
    )],
    [1, GameColor.kGreen, table(
        [1, "fullEnergy", 10],
        [1, "damage", 1],
        [1, "skills", table()]
    )],
    [1, GameColor.kBrown, table(
        [1, "fullEnergy", 25],
        [1, "damage", 4],
        [1, "skills", table()]
    )],
    [1, GameColor.kBlue, table(
        [1, "fullEnergy", 15],
        [1, "damage", 1],
        [1, "skills", table([0, table(
                [1, "skillType", PetSkillType.kChangeToSpecial],
                [1, "speicalType", 9],
                [1, "speicalNum", 1]
            )])]
    )],
    [1, GameColor.kRed, table(
        [1, "fullEnergy", 15],
        [1, "damage", 1],
        [1, "skills", table([0, table(
                [1, "skillType", PetSkillType.kBomb],
                [1, "speicalType", 0],
                [1, "speicalNum", 2]
            )])]
    )],
    [1, GameColor.kYellow, table(
        [1, "fullEnergy", 15],
        [1, "damage", 1],
        [1, "skills", table([0, table(
                [1, "skillType", PetSkillType.kChangeToSpecial],
                [1, "speicalType", 8],
                [1, "speicalNum", 1]
            )])]
    )]
))
MysteryPetSkillConfig = table(
    [1, AnimalTypeConfig.kBlue, table(
        [1, "skillType", PetSkillType.kChangeToSpecial],
        [1, "speicalType", AnimalTypeConfig.kColumn],
        [1, "speicalNum", 5]
    )],
    [1, AnimalTypeConfig.kGreen, table(
        [1, "skillType", PetSkillType.kChangeToSpecial],
        [1, "speicalType", AnimalTypeConfig.kFourTile],
        [1, "speicalNum", 5]
    )],
    [1, AnimalTypeConfig.kOrange, table(
        [1, "skillType", PetSkillType.kChangeToSpecial],
        [1, "speicalType", AnimalTypeConfig.kWrap],
        [1, "speicalNum", 5]
    )],
    [1, AnimalTypeConfig.kPurple, table(
        [1, "skillType", PetSkillType.kChangeToSpecial],
        [1, "speicalType", AnimalTypeConfig.kColor],
        [1, "speicalNum", 1]
    )],
    [1, AnimalTypeConfig.kRed, table(
        [1, "skillType", PetSkillType.kBomb],
        [1, "speicalType", 0],
        [1, "speicalNum", 7]
    )],
    [1, AnimalTypeConfig.kYellow, table(
        [1, "skillType", PetSkillType.kChangeToSpecial],
        [1, "speicalType", AnimalTypeConfig.kLine],
        [1, "speicalNum", 5]
    )]
)
// 果酱触发爆炸的界限
GamePlayConfig_Jam_Jar_Max_Strength = 4
GamePlayConfig_Jam_Jar_Dec_Time = 5 * GamePlayConfig_Action_FPS_Time_Scale

GamePlayConfig_SCORE_NORMAL_ANIMAL = 20
GamePlayConfig_SCORE_BARRIER_LOW = 100
GamePlayConfig_SCORE_BARRIER_HIGH = 500
GamePlayConfig_SCORE_SPECIAL_TARGET = 10000
GamePlayConfig_SCORE_LINE = 300
GamePlayConfig_SCORE_FOUR_TILE = 300
GamePlayConfig_SCORE_WRAP = 300
GamePlayConfig_SCORE_COLOR = 500
GamePlayConfig_SCORE_SUPER_BIRD = 500
GamePlayConfig_SCORE_COLORED_FROSTING = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_ROCKET = GamePlayConfig_SCORE_BARRIER_LOW
GamePlayConfig_SCORE_NEST_DOLL = GamePlayConfig_SCORE_BARRIER_LOW
GamePlayConfig_SCORE_GUMMY_WORM = GamePlayConfig_SCORE_BARRIER_LOW
GamePlayConfig_SCORE_CAKE_SHOOTER = GamePlayConfig_SCORE_BARRIER_LOW
GamePlayConfig_SCORE_ICE_BOMB = GamePlayConfig_SCORE_BARRIER_LOW
GamePlayConfig_SCORE_FISH = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_STARFISH_DEC = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_BLOCK = GamePlayConfig_SCORE_NORMAL_ANIMAL
GamePlayConfig_SCORE_BEE_JAR = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_BEE = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_ICE = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_SNOW = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_VAR_SNOW = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_CAGE = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_COIN = GamePlayConfig_SCORE_BARRIER_LOW
GamePlayConfig_SCORE_CRYSTAL = GamePlayConfig_SCORE_BARRIER_LOW
GamePlayConfig_SCORE_GIFT_BOX = GamePlayConfig_SCORE_BARRIER_LOW
GamePlayConfig_SCORE_NORMAL_CLOUD = GamePlayConfig_SCORE_BARRIER_LOW
GamePlayConfig_SCORE_GEM_CLOUD = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_ICICLE = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_SEA_ANIMAL = GamePlayConfig_SCORE_SPECIAL_TARGET
GamePlayConfig_SCORE_ROOST = GamePlayConfig_SCORE_BARRIER_LOW
GamePlayConfig_SCORE_BOMB = GamePlayConfig_SCORE_BARRIER_LOW
GamePlayConfig_SCORE_SAND = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_FURBALL = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_SUBMARINE = GamePlayConfig_SCORE_SPECIAL_TARGET
GamePlayConfig_SCORE_REEF = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_SOIL = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_BOAT = GamePlayConfig_SCORE_SPECIAL_TARGET
GamePlayConfig_SCORE_WATER_BOMB = GamePlayConfig_SCORE_BARRIER_LOW
GamePlayConfig_SCORE_VARIOUS_BOX = GamePlayConfig_SCORE_BARRIER_LOW
GamePlayConfig_SCORE_RABBIT = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_BIG_BOX = GamePlayConfig_SCORE_SPECIAL_TARGET
GamePlayConfig_SCORE_RICE_BAG = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_RATEL = GamePlayConfig_SCORE_BARRIER_HIGH * 2
GamePlayConfig_SCORE_CAPSULE_TOY = GamePlayConfig_SCORE_BARRIER_HIGH / 2
GamePlayConfig_SCORE_CHEESE_RAT_WOOD = GamePlayConfig_SCORE_BARRIER_LOW
GamePlayConfig_SCORE_CHEESE_RAT_RAT = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_CROISSANT = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_POPCAN = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_FILBERT_ONELEVEL = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_FILBERT_FINAL = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_FIREWORK = GamePlayConfig_SCORE_BARRIER_LOW
GamePlayConfig_SCORE_FIRECRACKER = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_FOAMBOMB = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_MANGOSTEEN = GamePlayConfig_SCORE_BARRIER_HIGH
GamePlayConfig_SCORE_MULTIPLY_LINE = 2
GamePlayConfig_SCORE_MULTIPLY_FOUR_TILE = 2
GamePlayConfig_SCORE_MULTIPLY_WRAP = 2
GamePlayConfig_SCORE_MULTIPLY_COLOR = 2.5
GamePlayConfig_SCORE_MULTIPLY_SUPER_BIRD = 3
GamePlayConfig_SCORE_MULTIPLY_LINE_AND_LINE = 3
GamePlayConfig_SCORE_MULTIPLY_LINE_AND_FOUR_TILE = 3
GamePlayConfig_SCORE_MULTIPLY_FOUR_TILE_AND_FOUR_TILE = 3
GamePlayConfig_SCORE_MULTIPLY_LINE_AND_WRAP = 3.5
GamePlayConfig_SCORE_MULTIPLY_WRAP_AND_FOUR_TILE = 3.5
GamePlayConfig_SCORE_MULTIPLY_WRAP_AND_WRAP = 3.5
GamePlayConfig_SCORE_MULTIPLY_COLOR_AND_COLOR = 4.5
GamePlayConfig_SCORE_MULTIPLY_SUPER_BIRD_AND_COLOR = 4.5
GamePlayConfig_SCORE_MULTIPLY_SUPER_BIRD_AND_SUPER_BIRD = 4.5
GamePlayConfig_SCORE_MULTIPLY_WATER_BOMB = 2
GamePlayConfig_BONUS_TIME_SCORE = 5000
GamePlayConfig_BONUS_TIME_ADD_SCORE = 1000
GamePlayConfig_BONUS_TIME_MAX_SCORE = 10000
GamePlayConfig_COMBO_MAX = 10
GamePlayConfig_COMBO_MAX_OF_MUSIC = 8
GamePlayConfig_DELAY_NORMAL_TIME = 45
GamePlayConfig_DELAY_MAX_TIME = 1892160000
GamePlayConfig_DELAY_MAX_TIME_DOUBLE = 2 * GamePlayConfig_DELAY_MAX_TIME
GamePlayConfig_Eliminate_Advise_SuperBird = 80
GamePlayConfig_Eliminate_Advise_Color = 70
GamePlayConfig_Eliminate_Advise_Fish = 60
GamePlayConfig_Eliminate_Advise_SpecialSwap = 50
GamePlayConfig_Eliminate_Advise_ColorNormal = 10
GamePlayConfig_Eliminate_Advise_SuperBirdNormal = 10
GamePlayConfig_Eliminate_Advise_NuclearNormal = 11
GamePlayConfig_Eliminate_Advise_Wrap = 40
GamePlayConfig_Eliminate_Advise_FourTile = 20
GamePlayConfig_Eliminate_Advise_Line = 20
GamePlayConfig_Eliminate_Advise_Normal = 10
GamePlayConfig_Dynamic_Guide_54 = 50
GamePlayConfig_Dynamic_Guide_44 = 40
GamePlayConfig_Fish_Move_Back_Block = 36
GamePlayConfig_Fish_Move_Time_Scale = 0.4
GamePlayConfig_Fish_Produce_Time_Scale = 0.32
GamePlayConfig_Fish_Back_Move_Time_Scale = 0.15
GamePlayConfig_Advice_Eliminate_Time_Interval = 4
GamePlayConfig_Falling_Effect_Elastic = 1
GamePlayConfig_Order_Target_Fly_BaseTime = 0.7
GamePlayConfig_Order_Target_Fly_AddTime = 0.005
GamePlayConfig_Order_Target_Fly_Up_Acceleration = 0.5
GamePlayConfig_Order_Target_Fly_Down_Acceleration = 0.5
GamePlayConfig_Order_Target_Fly_DownTime = 6 / 30
GamePlayConfig_Fish_Struggle_Count = 4
GamePlayConfig_Fish_Collect_Basic_Time = 0.75
GamePlayConfig_Fish_Collect_Ac_Time = 0.45
GamePlayConfig_Fish_Curve_Controll = 1.2
GamePlayConfig_Map_Gradient_Height = 300
GamePlayConfig_Jellyfish_Wait_Steps = 5
GamePlayConfig_Lighthouse_light = 1
GamePlayConfig_Magic_Spread = 20 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Weekly_Rabbit_Limit_Advice = 5
GamePlayConfig_Weekly_Rabbit_Light_FadeIn_Time = 10 / 30
GamePlayConfig_Weekly_Rabbit_Light_FadeOut_Time = 15 / 30
GamePlayConfig_Weekly_Rabbit_Tip_FadeIn_Time = 10 / 30
GamePlayConfig_Weekly_Rabbit_Tip_FadeOut_Time = 10 / 30
GamePlayConfig_Weekly_Rabbit_Tip_Time = (GamePlayConfig_Weekly_Rabbit_Tip_FadeIn_Time + GamePlayConfig_Weekly_Rabbit_Tip_FadeOut_Time) * 2
GamePlayConfig_Weekly_Rabbit_Tile_Tip_Time = GamePlayConfig_Weekly_Rabbit_Tip_FadeIn_Time + GamePlayConfig_Weekly_Rabbit_Tip_FadeOut_Time
GamePlayConifg_Weekly_Game_Guid_ID = 7000003
GamePlayConfig_Cake_Destroy_Time = 45 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Cake_Lock_Time = 15 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Beehive_Bee_Appear = 25
GamePlayConfig_Beehive_Bee_Fly_Center = GamePlayConfig_Beehive_Bee_Appear + 0.7 * 60
GamePlayConfig_Beehive_Turned = GamePlayConfig_Beehive_Bee_Fly_Center + 30
GamePlayConfig_Beehive_Bee_Fly_Boss = GamePlayConfig_Beehive_Turned + 41
GamePlayConfig_Beehive_Boss_Update_Blood = GamePlayConfig_Beehive_Bee_Fly_Boss + 47
GamePlayConfig_Beehive_Over = GamePlayConfig_Beehive_Boss_Update_Blood + 80
GamePlayConfig_Animal_Coin_Product_Prob = 20
GamePlayConfig_Animal_Coin_Product_Max = 0
GamePlayConfig_Animal_Coin_Product_Steps = 5
GamePlayConfig_Animal_Coin_Product_Num = 5
GamePlayConfig_Animal_Coin_Target_Fail_Get = 0.1
GamePlayConifg_Animal_Coin_Limit = table(
    [0, table([1, "level", 50], [1, "num", 10])],
    [0, table([1, "level", 100], [1, "num", 15])],
    [0, table([1, "level", 500], [1, "num", 30])],
    [0, table([1, "level", 9999], [1, "num", 30])]
)
GamePlayConfig_FourTile_Guide_Level_Reach = 50
GamePlayConfig_FourTile_Guide_EndTimes_Reach = 10
GamePlayConfig_FourTile_Level_List = table(
    [0, table([1, "level", 27], [1, "max", 6])],
    [0, table([1, "level", 32], [1, "max", 7])],
    [0, table([1, "level", 34], [1, "max", 7])],
    [0, table([1, "level", 41], [1, "max", 9])]
)
NewAreaUnlockConfig_Camera_Move_Time = 1.0
NewAreaUnlockConfig_Node_FadeIn_Interval = 0.07
NewAreaUnlockConfig_Node_FadeIn_Time = 1
NewAreaUnlockConfig_Camera_Move_ExtraDistance = 400
NewAreaUnlockConfig_Head_Jump_Delay_Time = 1
kTileCharacterAnimation = table(
    [1, "kNormal", 1],
    [1, "kUp", 2],
    [1, "kDown", 3],
    [1, "kLeft", 4],
    [1, "kRight", 5],
    [1, "kLineColumn", 6],
    [1, "kLineRow", 7],
    [1, "kWrap", 8],
    [1, "kSelect", 9],
    [1, "kDestroy", 10],
    [1, "kFourTile", 11],
    [1, "kSuperBird", 12],
    [1, "kFourTileHalf", 13],
    [1, "kSuperBirdIntoFlicker", 14]
)
kTileBirdAnimation = table(
    [1, "kNormal", 1],
    [1, "kSelect", 2],
    [1, "kDestroy", 3]
)
GamePlayConfig_Cancel_ColorAdjust_Combo_Num = 15
GamePlayConfig_SuperBirdBig_Num = 3
GamePlayConfig_ColorBig_Num = 3
GamePlayConfig_MissileBig_Num = 30
GamePlayConfig_MissileBig_Bomb_Count = 3
GamePlayConfig_LineReplace_Num = 5
GamePlayConfig_XLineReplace_Num = 5
GamePlayConfig_Plane_Prop_num = 5
GamePlayConfig_Multi_Hammer_Effect_Times = 1
GamePlayConfig_BearWolf_Change_Num = 5
GamePlayConfig_SpecialBomb_XLine_Time = 10 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Prop_Action_Line_Replace = 10 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Prop_Action_River_Clean = 10 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Prop_Action_Bomb_Twice = 10 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_ChangeSpecialPropConfig = table(
    [0, table([1, "speicalType", 10], [1, "rate", 50])],
    [0, table([1, "speicalType", 11], [1, "rate", 30])],
    [0, table([1, "speicalType", 12], [1, "rate", 20])]
)
GamePlayConfig_Enter_Next_Child_Level_Wait_Time = 3 * GamePlayConfig_Action_FPS
// GamePlayConfig_Level_Size_Island = 10
GamePlayConfig_Pursue_Paw_Fly = 27 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Pursue_Paw_Collect = GamePlayConfig_Pursue_Paw_Fly + 60 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_PropBlock_Step_Max = 5
GamePlayConfig_Dec_Time = 10 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Pursue_GoAhead = 20 * GamePlayConfig_Action_FPS_Time_Scale
GlobalRankListMax = 8000
GamePlayConfig_WeekGameEndLevelCountDown = 10
GamePlay_Collect_Random_Seed_Range = 1000
CONST_COLOR_COLLECTOR_BOMB_COUNT = 30
GamePlayConfig_SpecialBomb_ColorCollector = 93 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_GOLD_TOTAL_LEVELS = 30
GamePlayConfig_GOLD_CACHE_DATA_VERSION = 1
CONST_SURPRISE_BOX_LEVEL = 3
CONST_SOIL_LOCK_LEVEL = 999999
GamePlayConfig_BlockMachine_Product_Interval = 5
GamePlayConfig_Bowknot_Bomb_Num = 4
GamePlayConfig_Hammer_Big_Bomb_Time_InterVal = 6
GamePlayConfig_CandyFloss_Dec_Time = 20 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_CandyFloss_Change_Tail_Wait_Time = 3 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Gold_Scroll_One_Row_Time = 0.3
GamePlayConfig_ScoreAnimal_Step_Init = 8 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_ScoreAnimal_Score = 10000
GamePlayConfig_Bowknot_Dec_Time = 33 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Shell_Dec_Time = 10 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_WaterBox_Dec = 5 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_Vulnerable_Dec = 5 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_ColoredFrosting_Dec = 5 * GamePlayConfig_Action_FPS_Time_Scale
GamePlayConfig_GameBoard_Speed_Select_Default = 0
GamePlayConfig_GameBoard_Speed_Select_TimeBlockCollectionMode = 2
GamePlayConfig_GameBoard_Speed_Select_BuildShip = 1
GamePlayConfig_GameBoard_Speed_Replay = 3
GamePlayConfig_GameBoard_Speed = [1, 1.5, 2, 2.5]
GamePlayConfig_Nuclear_Score = 5000